import { environment } from '@environment';

export const hotelDetailApi = {
  hotel_detail: `${environment.api.travel_static_content}/hotel/details?` +
    'searchId={SearchId}&hotelOptionId={HotelOptionId}&locale={language}',
  hotel_deeplink: `${environment.api.netactica}/Hotel/ByHotelId`,
  hotel_byhours_deeplink: `${environment.api.netactica}/Hotel/ByHotelIdMicroStay`
};
